export const riverKeys = {
  LIBRARY_PICKS: 'library-picks',
  YOUR_REPORTS: 'your-reports',
  UPCOMING: 'upcoming',
  SEARCH: 'search',
  MY_FW: 'my-fw',
  EVENTS: 'events',
  STORY_WATCH: 'story-watch',
  TAG: 'tag'
}

export const SPONSORED_HEADLINES_INTERVAL = 10

export const PAGES_WITH_NO_PREFIX = ['/river/your-reports']
